<template>
  <div class="field">
    <label :class="this.$parent.isFieldRequired(this.keyData) ? 'req': ''" class="required">{{ label }}</label>
    <input :disabled="isDataUpdating" :value="currentDataFormated" @change="onInputChange" type="date">
  </div>
</template>

<script>
import moment from 'moment';
import 'moment-timezone';
import axios from "axios";
export default {
  name: "DataInput.vue",
  props: [
    'currentData',
    'keyData',
    'label',
    'type',
    'secondValue',
    'isDataUpdating'
  ],
  data() {
    return {

    }
  },
  methods: {
    updateServerValue(val) {
      let obj = {
        'projectVisual': {}
      };
      if (val === null) {
        obj.projectVisual[this.keyData] = null;
      }
      else {
        obj.projectVisual[this.keyData] = moment.tz(val, "Europe/Moscow").format();
      }
      this.$parent.isDataUpdating = true;
      axios.patch('/api/projects/' + window.projectId,
        obj,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/merge-patch+json',
          }
        }
      ).then(() => {
        this.$parent.getData()
      }).catch(error => {
        console.log(error);
        alert('Ошибка получения данных')
      });
    },
    onInputChange(e) {
      if (e.target.value.length === 0) {
        this.$parent.projectVisual[this.keyData] = null;
        this.updateServerValue(null);
        return;
      }

      if (this.type === "min" && this.secondValue < moment.tz(e.target.value, "Europe/Moscow").format()) {
        this.$parent.projectVisual[this.keyData] = null;
        alert("Значение не может быть больше поля ниже.");
        return
      }
      if (this.type === "max" && this.secondValue > moment.tz(e.target.value, "Europe/Moscow").format()) {
        this.$parent.projectVisual[this.keyData] = null;
        alert("Значение не может быть меньше поля выше.");
        return
      }
      this.updateServerValue(e.target.value);
    }
  },
  computed: {
    currentDataFormated() {
      return moment(this.currentData).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>

</style>